<script setup lang="ts">

import CheckoutOrderConfirmationDetails from "@/checkout/components/CheckoutOrderConfirmationDetails.vue";
import CheckoutSummary from "@/checkout/components/CheckoutSummary.vue";
import CheckoutHeader from "@/checkout/components/CheckoutHeader.vue";
import {useCheckoutStore} from "@/checkout/stores/checkout.store.ts";
import {faLeftFromBracket} from "@fortawesome/pro-regular-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";

interface Props {
  checkoutId: string
}

defineProps<Props>()
const checkout = useCheckoutStore();

</script>

<template>
  <div class="bg-white">
    <!-- Background color split screen for large screens -->
    <div class="fixed left-0 top-0 hidden h-full w-1/2 bg-white lg:block" aria-hidden="true"></div>
    <div class="fixed right-0 top-0 hidden h-full w-1/2 bg-gray-50 lg:block" aria-hidden="true"></div>

    <CheckoutHeader :step="3">
      <a v-if="checkout.config" :href="checkout.config.completedReturn.url" class="text-slate-500 hover:text-gray-900">
        <FontAwesomeIcon :icon="faLeftFromBracket" class="mr-2"/>
        <span v-html="checkout.config.completedReturn.label"/>
      </a>
    </CheckoutHeader>

    <main v-if="!checkout.loading" class="relative mx-auto grid max-w-7xl grid-cols-1 gap-x-16 lg:grid-cols-2 lg:px-8 xl:gap-x-48">
      <CheckoutSummary/>

      <CheckoutOrderConfirmationDetails/>

    </main>
  </div>
</template>

<style scoped>

</style>